import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import { TrashBinMinimalistic } from "@solar-icons/react/ssr";
import { Grid, Button } from "@mui/material";

export default function DeleteRowButton(props) {
    // TODO: add progress circle
    const { handleDeleteConfirm, iconButtonSize, iconSize } = props;
    const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);

    return (
        <>
            {isConfirmingDelete ? (
                <Grid container width={150}>
                    <Grid container justifyContent={"center"}>
                        Delete for sure?
                    </Grid>
                    <Grid item justifyContent={"center"}>
                        <Button
                            onClick={() => {
                                setIsConfirmingDelete(false);
                            }}
                            sx={{ padding: "0px" }}
                        >
                            No
                        </Button>
                        <Button
                            data-testid="delete-row-confirm-yes"
                            onClick={() => {
                                setIsConfirmingDelete(false);
                                handleDeleteConfirm();
                            }}
                            sx={{ padding: "0px" }}
                        >
                            Yes
                        </Button>
                    </Grid>
                </Grid>
            ) : (
                <IconButton
                    data-testid="delete-row-button"
                    size={iconButtonSize}
                    onClick={() => {
                        setIsConfirmingDelete(true);
                    }}
                >
                    <TrashBinMinimalistic
                        size={iconSize === "small" ? 18 : 24}
                    />
                </IconButton>
            )}
        </>
    );
}
